import React from 'react';

const PerformanceCard = ({ icon, title, value ,filters }) => {
  const colorMap = {
    "Yesterday's Performance": {
      iconBg: 'bg-white',
      iconColor: '#EE1D23',
      textColor: '#1A2B5C',
      gradientBorder: 'from-[#EE1D23] to-[#FF9E80]',
      cardBg: 'bg-[#FFF1F0]', // Soft red/pink
    },
    "MTD Performance": {
      iconBg: 'bg-white',
      iconColor: '#1A2B5C',
      textColor: '#1A2B5C',
      gradientBorder: 'from-[#1A2B5C] to-[#4B79A1]',
      cardBg: 'bg-[#F0F4FF]', // Light blue-gray
    },
    "YTD Performance": {
      iconBg: 'bg-white',
      iconColor: '#EE1D23',
      textColor: '#1A2B5C',
      gradientBorder: 'from-[#EE1D23] to-[#FF9E80]',
      cardBg: 'bg-[#FFF1F0]', // Light cyan-blue
    },
  };

  const {
    iconBg,
    iconColor,
    textColor,
    gradientBorder,
    cardBg,
  } = colorMap[title] || {
    iconBg: 'bg-white',
    iconColor: '#333',
    textColor: '#3b3b3b',
    gradientBorder: 'from-gray-200 to-gray-100',
    cardBg: 'bg-white',
  };

  return (
    <div
      className={`relative group p-[2px] rounded-[2rem] bg-gradient-to-br shadow-md hover:scale-[1.04] transition-transform duration-300 ${gradientBorder}`}
    >
      {/* Inner card */}
      <div className={`rounded-[2rem] ${cardBg} backdrop-blur-xl p-6 md:p-7 relative z-10 overflow-hidden`}>

        {/* Decorative subtle lines */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-0">
          <svg className="w-full h-full" viewBox="0 0 200 200" preserveAspectRatio="none">
            <line x1="0" y1="0" x2="200" y2="200" stroke="#ffffff11" strokeWidth="1" />
            <line x1="0" y1="20" x2="180" y2="200" stroke="#ffffff11" strokeWidth="1" />
            <line x1="20" y1="0" x2="200" y2="180" stroke="#ffffff11" strokeWidth="1" />
          </svg>
        </div>

        {/* Card content */}
        <div className="relative z-10 flex items-center space-x-6">
          <div className={`w-16 h-16 flex items-center justify-center rounded-full ${iconBg} shadow-md transition-transform group-hover:scale-110`}>
            {React.cloneElement(icon, { size: 30, color: iconColor })}
          </div>

          <div className="transition-transform group-hover:scale-[1.02]">
            <h4 className="text-base md:text-lg font-semibold" style={{ color: textColor }}>
              {title}
            </h4>
            <p className="text-3xl font-extrabold mt-1" style={{ color: textColor }}>
              {value}%
            </p>
          </div>
        </div>
      </div>

      {/* Glow ring */}
      <div className="absolute inset-0 rounded-[2rem] z-0 pointer-events-none group-hover:animate-pulse"
        style={{ boxShadow: `0 0 8px 1px rgba(255,255,255,0.12)` }}
      ></div>
    </div> 
  );
};

export default PerformanceCard;
